/**
 * A tiny inline-SVG icon set mirroring the app's Ionicons (outline) glyphs, so
 * the portal shares the app's iconography without pulling in @expo/vector-icons
 * or any React Native dependency. Paths are the Ionicons v7 outline vectors,
 * drawn with `currentColor` so the surrounding CSS `color` controls the stroke.
 */

type IconName = 'camera' | 'attach' | 'document';

const PATHS: Record<IconName, React.ReactNode> = {
  // ionicons: camera-outline
  camera: (
    <>
      <path
        d="M350.54 148.68l-26.62-42.06C318.31 100.08 310.62 96 302 96h-92c-8.62 0-16.31 4.08-21.92 10.62l-26.62 42.06C155.85 155.23 148.62 160 140 160H80a32 32 0 00-32 32v192a32 32 0 0032 32h352a32 32 0 0032-32V192a32 32 0 00-32-32h-59.46c-8.62 0-16.39-4.77-21.99-11.32z"
        fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={32}
      />
      <circle cx="256" cy="272" r="80" fill="none" stroke="currentColor" strokeMiterlimit={10} strokeWidth={32} />
      <path d="M124 158v-22h-24v22" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={32} />
    </>
  ),
  // ionicons: attach-outline (paperclip)
  attach: (
    <path
      d="M216.08 192v143.85a40.08 40.08 0 0080.15 0l.13-188.55a67.94 67.94 0 10-135.87 0v189.82a95.51 95.51 0 10191 0V159.74"
      fill="none" stroke="currentColor" strokeLinecap="round" strokeMiterlimit={10} strokeWidth={32}
    />
  ),
  // ionicons: document-attach-outline
  document: (
    <>
      <path
        d="M304 176V88a56.06 56.06 0 00-56-56H88a56.06 56.06 0 00-56 56v240a56.06 56.06 0 0056 56h80"
        fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={32}
      />
      <path
        d="M320 240l-84.68 85.28a24.39 24.39 0 000 34.43h0a24.39 24.39 0 0034.42 0L424 191.17a55.38 55.38 0 000-78.06h0a55.38 55.38 0 00-78.28 0L204.68 254.53a86.35 86.35 0 000 122h0a86.35 86.35 0 00122 0L416 288"
        fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={32}
      />
    </>
  ),
};

export function Icon({ name, size = 20, color = 'currentColor' }: { name: IconName; size?: number; color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 512 512" style={{ color, display: 'block' }} aria-hidden>
      {PATHS[name]}
    </svg>
  );
}
